import axios from "axios";

export const LOGIN_URL = `/api/auth/login`;
export const REGISTER_URL = "/api/auth/signup";
export const REQUEST_PASSWORD_URL = "/api/auth/forgot-password";
export const RESET_PASSWORD_URL = "/api/auth/reset-password";
export const REFRESH_URL = `/api/auth/refresh`;
export const LOGIN_FACEBOOK_URL = `/api/auth/auth-facebook`;

export function login(email: string, password: string) {
  return axios.post(
    LOGIN_URL,
    { email, password },
    {
      withCredentials: true,
    }
  );
}

export function register(
  email: string,
  fullname: string,
  password: string,
  invitationToken: string
) {
  return axios.post(
    REGISTER_URL,
    { email, name: fullname, password, invitationToken },
    {
      withCredentials: true,
    }
  );
}

export function requestPassword(email: string) {
  return axios.post(
    REQUEST_PASSWORD_URL,
    { email },
    {
      withCredentials: true,
    }
  );
}

export function resetPassword(password, resetToken) {
  return axios.post(
    RESET_PASSWORD_URL,
    { password, resetToken },
    {
      withCredentials: true,
    }
  );
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(REFRESH_URL, { withCredentials: true });
}

export function authFacebook(access_token) {
  return axios.post(
    LOGIN_FACEBOOK_URL,
    {access_token: access_token},
    {
      withCredentials: true,
    }
  );
}
